<template>
  <div
    v-if="lastSeenProducts && lastSeenProducts.length"
    ref="lastSeenProductsRef"
  >
    <ProductAnchorTitle
      :title="$t('Last seen')"
      class="mb-4"
    />
    <div>
      <SimpleCarousel
        class="carousel"
        :slider-items="lastSeenProducts"
        slide-class="carousel__item"
        :per-page="4"
        :arrows="true"
        :fixed-slide-width-value="150"
        wrapper-classes="lg:max-w-relatedProducts mx-auto"
        :gap="30"
        :breakpoints="RELATED_PRODUCTS_CONFIGURATION"
      >
        <template #default="{ currentItem }">
          <LastSeenProductCard
            :product="currentItem"
          />
        </template>
      </SimpleCarousel>
    </div>
  </div>
</template>

<script lang="ts">

import { useIntersectionObserver } from '@vueuse/core';
import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import { RELATED_PRODUCTS_CONFIGURATION } from '~~/constants/simpleCarousel';

import { EVENT_SOURCE } from '~~/constants/googleTagManager';
import { RECOMMENDATION_TYPE_NAME } from '~~/types/localization/localizationHelperTypes';

export default defineComponent({
  name: 'LastSeenProducts',

  setup() {

    const { lastSeenProducts } = useLastSeenProducts();

    const lastSeenProductsRef = ref<HTMLElement | null>(null);

    const { onIntersectOnce } = useRecommendationIntersection({
      lastSeenProducts,
      recommendationType: RECOMMENDATION_TYPE_NAME.LAST_SEEN,
    });
    useIntersectionObserver(lastSeenProductsRef, onIntersectOnce);

    return {
      lastSeenProducts,
      lastSeenProductsRef,
      LINK_TYPE,
      RELATED_PRODUCTS_CONFIGURATION,
      EVENT_SOURCE,
    };
  
  },
});

</script>
